import type { IMasterDataDistributionCenterRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataDistributionCentersDTO } from "@src/domain/dto/masterData";

export class GetMasterDataDistributionCentersUseCase {
  private readonly repository: IMasterDataDistributionCenterRepository;

  constructor(repository: IMasterDataDistributionCenterRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataDistributionCentersDTO) {
    return this.repository.getDistributionCenters(params);
  }
}
